module.exports = "<nv-react-component component=\"MyLearningPanel\"></nv-react-component>";